export const config = {
  title: "Jane Le Moine Waterway Realty | Woodlands, TX Real Estate Expert",
  meta: {
    description:
      "Jane Le Moine Waterway Realty helps you buy or sell homes in Woodlands, TX with expert guidance, personalized service, and deep local knowledge.",
    keywords: [
      "Jane Le Moine Waterway Realty",
      "Woodlands TX real estate",
      "top realtor Woodlands TX",
      "homes for sale Woodlands TX",
      "Texas real estate expert"
    ],
    author: "Jane Le Moine Waterway Realty",
    canonicalUrl: "https://www.topagentjane.com/",
  },
  sections: {
    header: {
      businessName: "Jane Le Moine Waterway Realty",
    },
    sectionB: {
      heroTitle: "Jane Le Moine Waterway Realty",
      heroSubtitle: "Helping You Buy or Sell in Woodlands, TX",
      learnAboutText: "Schedule a Consultation",
      phoneNumber: "2819485362",
      phoneLabel: "(281) 948-5362",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/2164822692/photo/suburban-sprawl.jpg?s=612x612&w=0&k=20&c=Z1eiTgQPjSVSpTwcNr7gcvIcBX8lMjCHeV_iDxqWONA=",
      cardData: [
        {
          title: "Home Buying",
          description: "Find your dream home in Woodlands with expert guidance.",
        },
        {
          title: "Home Selling",
          description: "Maximize your home’s value with proven selling strategies.",
        },
        {
          title: "Local Expertise",
          description: "Deep knowledge of Woodlands and surrounding communities.",
        },
      ],
      description:
        "Jane Le Moine is a trusted real estate professional based in Woodlands, TX, committed to making your buying or selling experience seamless and successful.",
    },
    sectionC: {
      servicesTitle: "What I Offer",
      servicesDescription:
        "Whether you're buying or selling, I provide end-to-end support and proven results.",
      cards: [
        {
          title: "Personalized Home Search",
          description: "Tailored listings based on your goals and budget.",
          imageSrc: "https://media.istockphoto.com/id/827615404/photo/paper-house-under-a-magnifying-lens.jpg?s=612x612&w=0&k=20&c=97KzqjE4gKtU5P0Bs3xFwbOLzNJtwWAnYPUZO1ZaaQI=",
          imageAlt: "Home Search",
        },
        {
          title: "Marketing & Staging",
          description: "Professional marketing, staging, and virtual tours to attract buyers.",
          imageSrc: "https://media.istockphoto.com/id/2197655235/photo/close-up-of-three-people-looking-at-financial-data-with-graphs-and-charts.jpg?s=612x612&w=0&k=20&c=rOX0dS9sbA5EaYkcj-UdjeboXoopcu4-dy6qp0XJy_c=",
          imageAlt: "Marketing Strategy",
        },
        {
          title: "Negotiation & Closing",
          description: "I handle negotiations and paperwork so you can relax.",
          imageSrc: "https://media.istockphoto.com/id/1497684257/photo/real-estate-agent-explain-house-plans-to-view-house-plans-and-sales-contracts-house-purchase.jpg?s=612x612&w=0&k=20&c=CUzac2HRc9FQW2at2fbDxVfYKRdNYvg6CcNl8D9IHAM=",
          imageAlt: "Real Estate Closing",
        },
      ],
      otherServicesTitle: "Why Work With Jane",
      otherServicesList: [
        "Top-Rated Local Realtor",
        "Personalized Approach",
        "Excellent Communication",
        "Proven Track Record",
        "Trusted in the Woodlands Area"
      ],
    },
    sectionD: {
      aboutTitle: "Meet Jane Le Moine",
      aboutImage: {
        src: "https://media.istockphoto.com/id/2199819733/photo/suburban-houston-subdivision.jpg?s=612x612&w=0&k=20&c=c7M1h42ipuIYQIrYT_Lg94tpLicKhj199KK0yCr4BZE=",
        alt: "Jane Le Moine Realtor",
      },
      aboutText: [
        "With years of experience helping clients navigate the real estate market, I offer honest advice, effective strategies, and reliable results.",
        "I’m passionate about helping individuals and families find their place in the Woodlands and surrounding areas."
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "Jane Le Moine Profile",
      businessName: "Jane Le Moine Waterway Realty",
      contact: {
        phone: "2819485362",
        phoneLabel: "(281) 948-5362",
        email: "janelemoine@juno.com",
        website: "https://www.topagentjane.com/",
        address: "594 SAWDUST RD #387, Woodlands, TX 77380, USA",
      },
      socialMedia: {},
    },
    sectionF: {
      address: "594 SAWDUST RD #387, Woodlands, TX 77380, USA",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3455.0509574130494!2d-95.4608445848825!3d30.12543078185462!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x86473113e3a6b80b%3A0x486d631e46045eea!2s594%20Sawdust%20Rd%20%23387%2C%20Spring%2C%20TX%2077380%2C%20USA!5e0!3m2!1sen!2sph!4v1694040219383!5m2!1sen!2sph",
    },
  },
};

export default config;
